import { SessionService } from '@users/session/SessionService';
import { getContainer } from '@framework/di/getContainer';
import { moduleMapper } from '@/creditflowresearch/application/constants';
import Logger from '@framework/sentry/Logger';
import { SenderFactory, SenderType } from '@framework/analytics-tracker/Sender';

export const useTrackAnalytics = () => {
  const container = getContainer();
  const sessionService = container.get(SessionService);

  const trackAnalytics = async ({ module }) => {
    const contactId = sessionService?.currentUser?.id;

    if (contactId) {
      const { trackKey } = moduleMapper[module];
      const senderFactory = container.get<SenderFactory>(SenderFactory);
      try {
        senderFactory.create(SenderType.Socket).track({
          eventName: trackKey,
          payload: { ...(contactId && { contactId }) },
        });
      } catch (error) {
        Logger.error({ message: 'Error tracking Finsight analytics', error });
      }
    }
  };

  return {
    trackAnalytics,
  };
};
